import { countVolumeReports } from '../helper'

export const VolumeCell = ({
  data,
  rowId,
  orderInfoKey,
  orderNameKey,
  orderIdKey,
  orderVolumeKey,
}) => {
  const volumeItems =
    countVolumeReports(
      data,
      rowId,
      orderInfoKey,
      orderNameKey,
      orderIdKey,
      orderVolumeKey,
    ) || {}
  return (
    <>
      {Object.values(volumeItems).length ? (
        Object.values(volumeItems).map((item, index) => (
          <div className={index !== 0 ? 'mt1' : ''} key={index}>
            {item}
          </div>
        ))
      ) : (
        <></>
      )}
    </>
  )
}
